<template>
    <div class="stepsdemo-content">
        <Card>
            <template v-slot:title>
                Riepilogo
            </template>
            <template v-slot:subtitle>
                I dati che hai inserito
            </template>
            <template v-slot:content>
                <div class="grid">
                    <div class="col-12 md:col-6"><b>Tipo Fornitura:</b>{{formData.tipo_fornitura.descrizione}}</div>
                    <!-- <div class="col-12 md:col-4"><b>Data Inizio:</b>{{reverseDate(formData.dataInizio)}}</div> -->
                    <div class="col-12 md:col-6"><b>Nome Offerta:</b>{{formData.nomeOfferta}}</div>
                    <div class="col-12 md:col-6"><b>Tipo Indicizzazione:</b>{{formData.indicizzazione.descrizione}}</div>
                    <div class="col-12 md:col-6"><b>Tipo Tariffazione:</b>{{formData.tariffazione.descrizione}}</div>
                    <div class="col-12 md:col-6"><b>Tipo Generalizzazione:</b>{{formData.generalizzazione.descrizione}}</div>
                    <div class="col-12 md:col-6"><b>Tipo Mercato:</b>{{formData.mercato.descrizione}}</div>

                    <div class="col-12 md:col-6"><b>Durata condizioni economiche:</b> {{formData.economic_conditions_duration_months ?? 12}} mesi</div>
                    <div class="col-12 md:col-6"><b>PCV Fix:</b>{{formData.pvcFix}}</div>
                    <div class="col-12 md:col-6"><b>Periodo PCV:</b>{{formData.periodo_pcv}}</div>
                    <div class="col-12 md:col-6"><b>PCV Variabile:</b>{{formData.pvcVariabile}}</div>
                    <div class="col-12 md:col-6"><b>Pa:</b>{{formData.pa}}</div>
                    <div class="col-12 md:col-6"><b>Sbilanciamento:</b>{{formData.sbilanciamento}}</div>
                    <div class="col-12 md:col-6"><b>Dep.Cauzionale:</b>{{formData.dep_cauzionale}}</div>
                    <!-- <div class="col-12 md:col-6"><b>Area Clienti:</b>{{formData.area_clienti}}</div> -->
                    <div class="col-12 md:col-6"><b>Rinnovo:</b>{{formData.rinnovo}}</div>
                    <div class="col-12 md:col-6"><b>Fattura cartacea selezionabile:</b>{{formData.can_select_ft_cartacea ? 'Si' : 'No'}}</div>
                </div>
                <div class="grid"  v-if="formData.tariffazione.id == 1">
                    <div class="col-12"><b>Mono:</b>{{formData.mono}}</div>
                </div>
                <div class="grid"  v-if="formData.tariffazione.id == 2">
                    <div class="col-12 md:col-6"><b>Peak:</b>{{formData.peak}}</div>
                    <div class="col-12 md:col-6"><b>OPeak:</b>{{formData.opeak}}</div>
                </div>
                <div class="grid"  v-if="formData.tariffazione.id == 3">   
                    <div class="col-12 md:col-4"><b>F1:</b>{{formData.f1}}</div>
                    <div class="col-12 md:col-4"><b>F2:</b>{{formData.f2}}</div>
                    <div class="col-12 md:col-4"><b>F3:</b>{{formData.f3}}</div>
                </div>
                <div class="grid mb-3" v-if="formData.agenti.length > 0">
                    <div class="col-12"><b>Agenti selezionati per l'offerta:</b></div>

                    <div class="scroll-container">
                        <Chip v-for="agente in formData.agenti" :key="agente.id" :label="agente.name" class="m-2"/>
                    </div>
                </div>
                <div class="grid" v-if="formData.tipo_fornitura.id == 1">
                    <div class="col-12 md:col-6"><b>Tensione:</b>{{formData.tensione.name}}</div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-6"><b>Data Inizio:</b>{{reverseDate(formData.dataInizio)}}</div>
                    <div class="col-12 md:col-6"><b>Data Fine:</b>{{reverseDate(formData.dataFine)}}</div>
                    <InlineMessage severity="info" class="w-full mt-2">Non dimenticare di assegnare il gettone</InlineMessage>

                    <!-- <div class="col-12 md:col-6"><b>Gettone1 <br><small>Valore</small></b>{{formData.gettone1}}</div>
                    <div class="col-12 md:col-6"><b>Gettone1 <br><small>Mesi</small></b>{{formData.gettone1_giorni}}</div>
                    <div class="col-12 md:col-6"><b>Gettone2 <br><small>Valore</small></b>{{formData.gettone2}}</div>
                    <div class="col-12 md:col-6"><b>Gettone2 <br><small>Mesi</small></b>{{formData.gettone2_giorni}}</div>
                    <div class="col-12 md:col-6"><b>Gettone3 <br><small>Valore</small></b>{{formData.gettone3}}</div>
                    <div class="col-12 md:col-6"><b>Gettone3 <br><small>Mesi</small></b>{{formData.gettone3_giorni}}</div>

                    <div class="col-12 md:col-4"><b>Gettone consumo:</b>{{formData.gettone_consumo}}</div>
                    <div class="col-12 md:col-4"><b>Gettone ricorrente punto:</b>{{formData.gettone_ric_punto}}</div>
                    <div class="col-12 md:col-4"><b>Gettone ricorrente consumo:</b>{{formData.gettone_ric_consumo}}</div> -->
                </div>
                <div class="pdf-preview-panel mt-4">
                    <div class="grid align-items-end">
                        <div class="col-12 flex gap-2">
                            <Button
                                label="Anteprima PDF"
                                icon="pi pi-file-pdf"
                                class="p-button-secondary"
                                :loading="previewLoading"
                                :disabled="previewLoading"
                                @click="previewPdf"
                            />
                            <Button
                                v-if="pdfPreviewUrl"
                                label="Apri"
                                icon="pi pi-external-link"
                                class="p-button-text"
                                @click="openPreviewInNewTab"
                            />
                        </div>
                    </div>
                    <div v-if="pdfPreviewUrl" class="pdf-preview-frame mt-3">
                        <iframe :src="pdfPreviewUrl" title="Anteprima PDF offerta"></iframe>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="grid justify-content-between">
                    <Button label="" @click="prevPage()" icon="pi pi-angle-left" iconPos="right" />
                    <i></i>
                    <Button  label="Salva" :disabled="isDisable" @click="complete()" icon="pi pi-check" iconPos="right" class="p-button-success"/>  
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import moment from 'moment'
import {ref, getCurrentInstance, onActivated, onBeforeUnmount} from 'vue'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Card from 'primevue/card';
import Button from 'primevue/button';


export default {
    components: {
        Card,
        Button,
    },
    props: {
        formData: Object
    },
    setup (props, {emit}) {
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        const service = new Service(self.$eventBus)
        const isDisable = ref(false);
        const previewLoading = ref(false)
        const pdfPreviewUrl = ref(null)
        const previewPayloadSignature = ref(null)
        const prevPage = () => {
            emit('prev-page', {pageIndex: 3});
        }
        const buildOffertaPayload = () => {
            const localData = { ...props.formData };
            localData.tensione = props.formData.tensione ? props.formData.tensione.id : null
            localData.agenti = props.formData.agenti.map(function(agente){
                return agente.id
            })
            return localData
        }
        const getPayloadSignature = () => {
            return JSON.stringify(buildOffertaPayload())
        }
        const revokePreviewUrl = () => {
            pdfPreviewUrl.value = null
        }
        const previewPdf = async () => {
            emit("activeLoader", true)
            previewLoading.value = true
            revokePreviewUrl()
            const localData = buildOffertaPayload()
            const payloadSignature = JSON.stringify(localData)

            const previewUrl = await service.getPdfOfferta(localData, true, true)

            if (previewUrl) {
                pdfPreviewUrl.value = previewUrl
                previewPayloadSignature.value = payloadSignature
            }

            previewLoading.value = false
            emit("activeLoader", false)
        }
        const openPreviewInNewTab = () => {
            if (pdfPreviewUrl.value) {
                window.open(pdfPreviewUrl.value, '_blank')
            }
        }
        const complete = async () => { 
            emit("activeLoader", true)
            const localData = buildOffertaPayload()
            service.saveOfferta(localData)
            .then((res) => {   
                isDisable.value = true
                if (!res) {
                    setTimeout(function() {
                        emit('complete');
                    }, 1800); 
                }          
            }).finally(() => {
                emit("activeLoader", false)
                isDisable.value = false
            })
        }

        const reverseDate = (data) => {
            return moment(data).format("DD-MM-YYYY")
        }

        onActivated(() => {
            if (pdfPreviewUrl.value && previewPayloadSignature.value !== getPayloadSignature()) {
                previewPdf()
            }
        })

        onBeforeUnmount(revokePreviewUrl)

        return {
            prevPage,
            complete,
            reverseDate,
            isDisable,
            previewLoading,
            pdfPreviewUrl,
            previewPdf,
            openPreviewInNewTab
        }
    },
    
}
</script>
<style scoped>
.rid {
    border: 1px solid rgba(51, 51, 51, 0.068);
    margin-top: 20px;
}

.scroll-container {
    padding-top: 5px;
    height: 50px;       /* Altezza fissa obbligatoria */
    overflow-y: auto;    /* Mostra lo scroll solo se serve */
}

.pdf-preview-panel {
    border-top: 1px solid rgba(51, 51, 51, 0.12);
    padding-top: 1rem;
}

.pdf-preview-frame {
    height: 70vh;
    min-height: 520px;
    border: 1px solid rgba(51, 51, 51, 0.16);
}

.pdf-preview-frame iframe {
    width: 100%;
    height: 100%;
    border: 0;
}
</style>
